import z from "zod"

export const submitCompanySchema = z.object({
  session_id: z.string(),
  company_id: z.coerce.number()
})

export const submitOrganizationSchema = z.object({
  session_id: z.string(),
  organization_id: z.coerce.number()
})

export type SubmitCompanyFormType = z.infer<typeof submitCompanySchema>
export type SubmitOrganizationFormType = z.infer<typeof submitOrganizationSchema>
